import { render, staticRenderFns } from "./UlbReport.vue?vue&type=template&id=71a9d75c&"
import script from "./UlbReport.vue?vue&type=script&lang=js&"
export * from "./UlbReport.vue?vue&type=script&lang=js&"
import style0 from "./UlbReport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports